import React from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { NODE_UI, stopPropagation } from './nodeUiStyles';

/**
 * NodeAddButton — "+ Add" for repeatable lists.
 * Theme outlined + dashed border (node density).
 */
const NodeAddButton = React.memo(function NodeAddButton({
  onClick,
  label = 'Add',
  icon,
  disabled = false,
  fullWidth = true,
  sx,
}) {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={icon || <AddIcon sx={{ fontSize: '16px !important' }} />}
      onClick={(e) => {
        stopPropagation(e);
        onClick?.(e);
      }}
      onMouseDown={stopPropagation}
      onPointerDown={stopPropagation}
      disabled={disabled}
      fullWidth={fullWidth}
      sx={{
        borderStyle: 'dashed',
        minHeight: 32,
        fontSize: NODE_UI.fontSize.value,
        fontWeight: NODE_UI.fontWeight.label,
        borderRadius: NODE_UI.borderRadiusSm,
        ...sx,
      }}
    >
      {label}
    </Button>
  );
});

export default NodeAddButton;
